import { createContext } from "react";

export interface DashboardContextType {
    noticePopUp: boolean;
}

export const DashboardContext = createContext<DashboardContextType | any>(
    undefined
);
